import redFlowerWide from '../images/optimized/red-flower-bed-wide-view-web.jpg';
import redFlowerWideThumb from '../images/optimized/red-flower-bed-wide-view-thumb.jpg';
import raisedBedsWide from '../images/optimized/wide-garden-view-with-covered-row-web.jpg';
import raisedBedsWideThumb from '../images/optimized/wide-garden-view-with-covered-row-thumb.jpg';
import tomatoMarigoldBed from '../images/optimized/tomatoes-and-marigolds-raised-bed-web.jpg';
import tomatoMarigoldBedThumb from '../images/optimized/tomatoes-and-marigolds-raised-bed-thumb.jpg';
import floweringBorder from '../images/optimized/flowering-border-wide-garden-view-web.jpg';
import floweringBorderThumb from '../images/optimized/flowering-border-wide-garden-view-thumb.jpg';
import leafyGreens from '../images/optimized/leafy-greens-row-with-sheds-web.jpg';
import leafyGreensThumb from '../images/optimized/leafy-greens-row-with-sheds-thumb.jpg';
import keyholeGarden from '../images/optimized/keyhole-garden-sign-and-bed-web.jpg';
import keyholeGardenThumb from '../images/optimized/keyhole-garden-sign-and-bed-thumb.jpg';
import gardenTools from '../images/optimized/garden-tools-and-wheelbarrow-corner-web.jpg';
import gardenToolsThumb from '../images/optimized/garden-tools-and-wheelbarrow-corner-thumb.jpg';
import youngVegetables from '../images/optimized/young-vegetable-bed-close-view-web.jpg';
import youngVegetablesThumb from '../images/optimized/young-vegetable-bed-close-view-thumb.jpg';
import fencePath from '../images/optimized/fence-side-garden-path-web.jpg';
import fencePathThumb from '../images/optimized/fence-side-garden-path-thumb.jpg';
import coveredBeds from '../images/optimized/covered-beds-and-benches-web.jpg';
import coveredBedsThumb from '../images/optimized/covered-beds-and-benches-thumb.jpg';
import gardenLawn from '../images/optimized/garden-lawn-with-raised-beds-web.jpg';
import gardenLawnThumb from '../images/optimized/garden-lawn-with-raised-beds-thumb.jpg';

// Additional gallery images
import cloudyGardenView from '../images/optimized/cloudy-garden-view-with-raised-beds-web.jpg';
import cloudyGardenViewThumb from '../images/optimized/cloudy-garden-view-with-raised-beds-thumb.jpg';
import coveredBedsWideLawn from '../images/optimized/covered-beds-wide-view-with-lawn-web.jpg';
import coveredBedsWideLawnThumb from '../images/optimized/covered-beds-wide-view-with-lawn-thumb.jpg';
import coveredRowLawn from '../images/optimized/covered-row-on-lawn-web.jpg';
import coveredRowLawnThumb from '../images/optimized/covered-row-on-lawn-thumb.jpg';
import fabricCoveredBeds from '../images/optimized/fabric-covered-garden-beds-close-view-web.jpg';
import fabricCoveredBedsThumb from '../images/optimized/fabric-covered-garden-beds-close-view-thumb.jpg';
import fenceSideRow from '../images/optimized/fence-side-garden-row-web.jpg';
import fenceSideRowThumb from '../images/optimized/fence-side-garden-row-thumb.jpg';
import flowerBorderVertical from '../images/optimized/flower-border-vertical-view-web.jpg';
import flowerBorderVerticalThumb from '../images/optimized/flower-border-vertical-view-thumb.jpg';
import floweringBorderYellow from '../images/optimized/flowering-border-with-yellow-blooms-web.jpg';
import floweringBorderYellowThumb from '../images/optimized/flowering-border-with-yellow-blooms-thumb.jpg';
import gardenRowsHoops from '../images/optimized/garden-rows-and-hoops-wide-view-web.jpg';
import gardenRowsHoopsThumb from '../images/optimized/garden-rows-and-hoops-wide-view-thumb.jpg';
import gardenerWorking from '../images/optimized/gardener-working-near-covered-beds-web.jpg';
import gardenerWorkingThumb from '../images/optimized/gardener-working-near-covered-beds-thumb.jpg';
import hoopCoveredGreensAngle from '../images/optimized/hoop-covered-greens-bed-angle-web.jpg';
import hoopCoveredGreensAngleThumb from '../images/optimized/hoop-covered-greens-bed-angle-thumb.jpg';
import joeTeaching from '../images/optimized/joeTeachingKidsGardening-web.jpg';
import joeTeachingThumb from '../images/optimized/joeTeachingKidsGardening-thumb.jpg';
import keyholeGardenDiagram from '../images/optimized/keyhole-garden-diagram-closeup-web.jpg';
import keyholeGardenDiagramThumb from '../images/optimized/keyhole-garden-diagram-closeup-thumb.jpg';
import leafyGreensCloseup from '../images/optimized/leafy-greens-closeup-row-web.jpg';
import leafyGreensCloseupThumb from '../images/optimized/leafy-greens-closeup-row-thumb.jpg';
import leafyShrub from '../images/optimized/leafy-shrub-closeup-web.jpg';
import leafyShrubThumb from '../images/optimized/leafy-shrub-closeup-thumb.jpg';
import lushTomatoBed from '../images/optimized/lush-tomato-bed-with-marigolds-web.jpg';
import lushTomatoBedThumb from '../images/optimized/lush-tomato-bed-with-marigolds-thumb.jpg';
import mixedVegetableMariogolds from '../images/optimized/mixed-vegetable-bed-with-marigolds-web.jpg';
import mixedVegetableMariogoldsThumb from '../images/optimized/mixed-vegetable-bed-with-marigolds-thumb.jpg';
import mixedVegetableOnions from '../images/optimized/mixed-vegetable-plot-with-onions-web.jpg';
import mixedVegetableOnionsThumb from '../images/optimized/mixed-vegetable-plot-with-onions-thumb.jpg';
import newGardenPlots from '../images/optimized/newGardenPlots-web.jpg';
import newGardenPlotsThumb from '../images/optimized/newGardenPlots-thumb.jpg';
import openGardenRows from '../images/optimized/open-garden-rows-with-hoops-web.jpg';
import openGardenRowsThumb from '../images/optimized/open-garden-rows-with-hoops-thumb.jpg';
import raisedBedUnderTrees from '../images/optimized/raised-bed-section-under-trees-web.jpg';
import raisedBedUnderTreesThumb from '../images/optimized/raised-bed-section-under-trees-thumb.jpg';
import raisedBedsHoopsWide from '../images/optimized/raised-beds-with-covered-hoops-wide-web.jpg';
import raisedBedsHoopsWideThumb from '../images/optimized/raised-beds-with-covered-hoops-wide-thumb.jpg';
import raisedBedsTrellis from '../images/optimized/raised-beds-with-trellis-and-tree-web.jpg';
import raisedBedsTrellisThumb from '../images/optimized/raised-beds-with-trellis-and-tree-thumb.jpg';
import redFlowerCloseup from '../images/optimized/red-flower-bed-closeup-web.jpg';
import redFlowerCloseupThumb from '../images/optimized/red-flower-bed-closeup-thumb.jpg';
import smallRaisedBedRowCover from '../images/optimized/small-raised-bed-with-row-cover-web.jpg';
import smallRaisedBedRowCoverThumb from '../images/optimized/small-raised-bed-with-row-cover-thumb.jpg';
import tomatoMarigoldCloseup from '../images/optimized/tomatoes-and-marigolds-closeup-web.jpg';
import tomatoMarigoldCloseupThumb from '../images/optimized/tomatoes-and-marigolds-closeup-thumb.jpg';
import trellisFabricCover from '../images/optimized/trellised-bed-with-fabric-cover-web.jpg';
import trellisFabricCoverThumb from '../images/optimized/trellised-bed-with-fabric-cover-thumb.jpg';
import vegetableRowsCropCovers from '../images/optimized/vegetable-rows-with-crop-covers-web.jpg';
import vegetableRowsCropCoversThumb from '../images/optimized/vegetable-rows-with-crop-covers-thumb.jpg';
import youngTomatoPlant from '../images/optimized/young-tomato-plant-with-cage-web.jpg';
import youngTomatoPlantThumb from '../images/optimized/young-tomato-plant-with-cage-thumb.jpg';
import youngVegetableBedCover from '../images/optimized/young-vegetable-bed-with-cover-web.jpg';
import youngVegetableBedCoverThumb from '../images/optimized/young-vegetable-bed-with-cover-thumb.jpg';
import communityGardenWelcomeSign from '../images/optimized/community-garden-welcome-sign-web.jpg';
import communityGardenWelcomeSignThumb from '../images/optimized/community-garden-welcome-sign-thumb.jpg';
import compostBinsWithGardenScraps from '../images/optimized/compost-bins-with-garden-scraps-web.jpg';
import compostBinsWithGardenScrapsThumb from '../images/optimized/compost-bins-with-garden-scraps-thumb.jpg';
import compostPileSignsOverBins from '../images/optimized/compost-pile-signs-over-bins-web.jpg';
import compostPileSignsOverBinsThumb from '../images/optimized/compost-pile-signs-over-bins-thumb.jpg';
import compostFoodWebSignCloseup from '../images/optimized/compost-food-web-sign-closeup-web.jpg';
import compostFoodWebSignCloseupThumb from '../images/optimized/compost-food-web-sign-closeup-thumb.jpg';
import decomposersCompostPileSignCloseup from '../images/optimized/decomposers-compost-pile-sign-closeup-web.jpg';
import decomposersCompostPileSignCloseupThumb from '../images/optimized/decomposers-compost-pile-sign-closeup-thumb.jpg';
import compostEducationSignsOnFence from '../images/optimized/compost-education-signs-on-fence-web.jpg';
import compostEducationSignsOnFenceThumb from '../images/optimized/compost-education-signs-on-fence-thumb.jpg';
import compostBinsAndBrushPile from '../images/optimized/compost-bins-and-brush-pile-web.jpg';
import compostBinsAndBrushPileThumb from '../images/optimized/compost-bins-and-brush-pile-thumb.jpg';
import tomatoBedWithBambooTrellis from '../images/optimized/tomato-bed-with-bamboo-trellis-web.jpg';
import tomatoBedWithBambooTrellisThumb from '../images/optimized/tomato-bed-with-bamboo-trellis-thumb.jpg';
import zucchiniPlantWithYoungSquash from '../images/optimized/zucchini-plant-with-young-squash-web.jpg';
import zucchiniPlantWithYoungSquashThumb from '../images/optimized/zucchini-plant-with-young-squash-thumb.jpg';
import pepperAndTomatoRaisedBed from '../images/optimized/pepper-and-tomato-raised-bed-web.jpg';
import pepperAndTomatoRaisedBedThumb from '../images/optimized/pepper-and-tomato-raised-bed-thumb.jpg';
import cabbageChardAndLavenderBed from '../images/optimized/cabbage-chard-and-lavender-bed-web.jpg';
import cabbageChardAndLavenderBedThumb from '../images/optimized/cabbage-chard-and-lavender-bed-thumb.jpg';
import stakedTomatoAndPepperBed from '../images/optimized/staked-tomato-and-pepper-bed-web.jpg';
import stakedTomatoAndPepperBedThumb from '../images/optimized/staked-tomato-and-pepper-bed-thumb.jpg';
import sunflowerFaceWithBee from '../images/optimized/sunflower-face-with-bee-web.jpg';
import sunflowerSideViewWithBuds from '../images/optimized/sunflower-side-view-with-buds-web.jpg';
import sunflowerSideViewWithBudsThumb from '../images/optimized/sunflower-side-view-with-buds-thumb.jpg';
import redBeeBalmFlowerCloseup from '../images/optimized/red-bee-balm-flower-closeup-web.jpg';
import redBeeBalmFlowerCloseupThumb from '../images/optimized/red-bee-balm-flower-closeup-thumb.jpg';
import shastaDaisiesAndCalendulaBorder from '../images/optimized/shasta-daisies-and-calendula-border-web.jpg';
import shastaDaisiesAndCalendulaBorderThumb from '../images/optimized/shasta-daisies-and-calendula-border-thumb.jpg';
import foxgloveAndConeflowerGardenBorder from '../images/optimized/foxglove-and-coneflower-garden-border-web.jpg';
import foxgloveAndConeflowerGardenBorderThumb from '../images/optimized/foxglove-and-coneflower-garden-border-thumb.jpg';
import raisedBedsWithSeedlingTableAndRowCovers from '../images/optimized/raised-beds-with-seedling-table-and-row-covers-web.jpg';
import raisedBedsWithSeedlingTableAndRowCoversThumb from '../images/optimized/raised-beds-with-seedling-table-and-row-covers-thumb.jpg';
import sunnyGardenBedsWithTomatoTrellises from '../images/optimized/sunny-garden-beds-with-tomato-trellises-web.jpg';
import sunnyGardenBedsWithTomatoTrellisesThumb from '../images/optimized/sunny-garden-beds-with-tomato-trellises-thumb.jpg';
import wideGardenBedsWithTrellisesAndRowCovers from '../images/optimized/wide-garden-beds-with-trellises-and-row-covers-web.jpg';
import wideGardenBedsWithTrellisesAndRowCoversThumb from '../images/optimized/wide-garden-beds-with-trellises-and-row-covers-thumb.jpg';
import goldfinchOnTomatoCage from '../images/optimized/goldfinch-on-tomato-cage-web.jpg';
import goldfinchOnTomatoCageThumb from '../images/optimized/goldfinch-on-tomato-cage-thumb.jpg';
import marigoldsLiatrisAndTomatoesRaisedBed from '../images/optimized/marigolds-liatris-and-tomatoes-raised-bed-web.jpg';
import marigoldsLiatrisAndTomatoesRaisedBedThumb from '../images/optimized/marigolds-liatris-and-tomatoes-raised-bed-thumb.jpg';
import longGardenRowsWithCoveredBeds from '../images/optimized/long-garden-rows-with-covered-beds-web.jpg';
import longGardenRowsWithCoveredBedsThumb from '../images/optimized/long-garden-rows-with-covered-beds-thumb.jpg';
import wideGardenPathWithRaisedBeds from '../images/optimized/wide-garden-path-with-raised-beds-web.jpg';
import wideGardenPathWithRaisedBedsThumb from '../images/optimized/wide-garden-path-with-raised-beds-thumb.jpg';

export { gardenImageLabels } from '../config/gardenImageLabels';

const DEFAULT_LIGHTBOX_ASPECT_RATIO = 1205 / 1600;
const LIGHTBOX_ASPECT_RATIOS = new Map([
  [joeTeaching, 863 / 805],
  [newGardenPlots, 760 / 507],
  [sunnyGardenBedsWithTomatoTrellises, 1600 / 1205],
  [wideGardenBedsWithTrellisesAndRowCovers, 1600 / 1205],
  [wideGardenPathWithRaisedBeds, 1600 / 1205],
]);

const withLightboxAspectRatio = (image) => ({
  ...image,
  aspectRatio: LIGHTBOX_ASPECT_RATIOS.get(image.url) || DEFAULT_LIGHTBOX_ASPECT_RATIO,
});

export const homepageImages = [
  {
    id: 1,
    url: redFlowerWide,
    thumbnailUrl: redFlowerWideThumb,
    description: 'Red bee balm flowers bloom in the foreground, with collards behind them and kale growing farther back.'
  },
  {
    id: 2,
    url: sunflowerFaceWithBee,
    description: 'A close view of a sunflower shows a bee gathering pollen on the flower head.'
  },
  {
    id: 3,
    url: tomatoMarigoldBed,
    thumbnailUrl: tomatoMarigoldBedThumb,
    description: 'Tomato plants climb green cages above orange and yellow marigolds.'
  }
].map(withLightboxAspectRatio);

const galleryImageItems = [
  {
    id: 1,
    url: redFlowerWide,
    thumbnailUrl: redFlowerWideThumb,
    description: 'Red bee balm flowers bloom in the foreground, with collards behind them and kale growing farther back.'
  },
  {
    id: 2,
    url: floweringBorder,
    thumbnailUrl: floweringBorderThumb,
    description: 'Red bee balm, yellow yarrow, and purple-flowering herbs fill the border beside the path.'
  },
  {
    id: 3,
    url: raisedBedsWide,
    thumbnailUrl: raisedBedsWideThumb,
    description: 'Raised beds with row covers protect young crops, with open growing rows beyond.'
  },
  {
    id: 4,
    url: gardenLawn,
    thumbnailUrl: gardenLawnThumb,
    description: 'Raised beds and crop covers spread across the lawn, with leafy brassicas visible near the front.'
  },
  {
    id: 5,
    url: leafyGreens,
    thumbnailUrl: leafyGreensThumb,
    description: 'Lacinato kale, curly kale, and collards fill neighboring raised beds.'
  },
  {
    id: 7,
    url: tomatoMarigoldBed,
    thumbnailUrl: tomatoMarigoldBedThumb,
    description: 'Tomato plants climb green cages above orange and yellow marigolds.'
  },
  {
    id: 8,
    url: youngVegetables,
    thumbnailUrl: youngVegetablesThumb,
    description: 'Onions, cucumber vines, and young seedlings grow around a tall sunflower and a pulled-back row cover.'
  },
  {
    id: 9,
    url: keyholeGarden,
    thumbnailUrl: keyholeGardenThumb,
    description: 'A straw-mulched keyhole bed sits below a fence sign explaining the planting design.'
  },
  {
    id: 10,
    url: gardenTools,
    thumbnailUrl: gardenToolsThumb,
    description: 'Tools, a wheelbarrow, and supplies are stored beside mesh-covered growing beds.'
  },
  {
    id: 11,
    url: fencePath,
    thumbnailUrl: fencePathThumb,
    description: 'A narrow path runs along the chain-link fence beside beds of vegetables and herbs.'
  },
  {
    id: 12,
    url: coveredBeds,
    thumbnailUrl: coveredBedsThumb,
    description: 'Mesh-covered raised beds and benches sit beside open growing areas.'
  },
  {
    id: 13,
    url: cloudyGardenView,
    thumbnailUrl: cloudyGardenViewThumb,
    description: 'Raised beds, fabric-covered rows, and open paths sit under a cloudy sky.'
  },
  {
    id: 15,
    url: coveredBedsWideLawn,
    thumbnailUrl: coveredBedsWideLawnThumb,
    description: 'Covered beds and open plots stretch across the lawn toward the shade trees.'
  },
  {
    id: 17,
    url: coveredRowLawn,
    thumbnailUrl: coveredRowLawnThumb,
    description: 'A single fabric-covered row protects young crops beside the open lawn.'
  },
  {
    id: 19,
    url: fabricCoveredBeds,
    thumbnailUrl: fabricCoveredBedsThumb,
    description: 'Several raised beds are protected by light fabric crop covers.'
  },
  {
    id: 20,
    url: fenceSideRow,
    thumbnailUrl: fenceSideRowThumb,
    description: 'A long planting row runs beside the black chain-link fence.'
  },
  {
    id: 22,
    url: flowerBorderVertical,
    thumbnailUrl: flowerBorderVerticalThumb,
    description: 'Pink foxglove blooms, coneflowers, daisy buds, and dense greenery rise along the mulched garden edge.'
  },
  {
    id: 23,
    url: floweringBorderYellow,
    thumbnailUrl: floweringBorderYellowThumb,
    description: 'Red bee balm and yellow yarrow bloom together near the growing rows.'
  },
  {
    id: 24,
    url: gardenRowsHoops,
    thumbnailUrl: gardenRowsHoopsThumb,
    description: 'Hoop supports arc over long rows of young crops beneath the open sky.'
  },
  {
    id: 25,
    url: gardenerWorking,
    thumbnailUrl: gardenerWorkingThumb,
    description: 'A gardener works beside mesh-covered beds and young crops.'
  },
  {
    id: 26,
    url: hoopCoveredGreensAngle,
    thumbnailUrl: hoopCoveredGreensAngleThumb,
    description: 'Beets, herbs, and purple-flowering plants grow inside a hoop-supported raised bed.'
  },
  {
    id: 27,
    url: joeTeaching,
    thumbnailUrl: joeTeachingThumb,
    description: 'Joe teaches children about growing vegetables during a hands-on lesson.'
  },
  {
    id: 28,
    url: keyholeGardenDiagram,
    thumbnailUrl: keyholeGardenDiagramThumb,
    description: 'A keyhole garden diagram sign hangs on a vine-covered fence.'
  },
  {
    id: 29,
    url: leafyGreensCloseup,
    thumbnailUrl: leafyGreensCloseupThumb,
    description: 'Collard leaves fill the foreground, with curly kale growing behind them.'
  },
  {
    id: 30,
    url: leafyShrub,
    thumbnailUrl: leafyShrubThumb,
    description: 'Dense green foliage fills the frame in a close-up plant portrait.'
  },
  {
    id: 31,
    url: lushTomatoBed,
    thumbnailUrl: lushTomatoBedThumb,
    description: 'Tomato plants grow through green cages above orange and yellow marigolds.'
  },
  {
    id: 32,
    url: mixedVegetableMariogolds,
    thumbnailUrl: mixedVegetableMariogoldsThumb,
    description: 'Calendula, cilantro flowers, squash leaves, and young vegetables share a straw-mulched bed.'
  },
  {
    id: 33,
    url: mixedVegetableOnions,
    thumbnailUrl: mixedVegetableOnionsThumb,
    description: 'Onions, borage, potatoes, and yellow-flowering brassicas grow together in a mixed bed.'
  },
  {
    id: 34,
    url: newGardenPlots,
    thumbnailUrl: newGardenPlotsThumb,
    description: 'Newly prepared plots wait for seedlings and summer crops.'
  },
  {
    id: 35,
    url: openGardenRows,
    thumbnailUrl: openGardenRowsThumb,
    description: 'Open rows with hoop supports shelter young vegetables between the beds.'
  },
  {
    id: 36,
    url: raisedBedUnderTrees,
    thumbnailUrl: raisedBedUnderTreesThumb,
    description: 'Raised beds and planting plots sit beneath mature shade trees.'
  },
  {
    id: 37,
    url: raisedBedsHoopsWide,
    thumbnailUrl: raisedBedsHoopsWideThumb,
    description: 'Hoop supports and crop covers protect rows of young vegetables.'
  },
  {
    id: 38,
    url: raisedBedsTrellis,
    thumbnailUrl: raisedBedsTrellisThumb,
    description: 'Trellised raised beds sit beneath a large shade tree.'
  },
  {
    id: 39,
    url: redFlowerCloseup,
    thumbnailUrl: redFlowerCloseupThumb,
    description: 'Tall red bee balm flowers bloom above purple-flowering herbs and silvery foliage.'
  },
  {
    id: 40,
    url: smallRaisedBedRowCover,
    thumbnailUrl: smallRaisedBedRowCoverThumb,
    description: 'A small bed holds tomatoes, basil, eggplant, and covered kale seedlings.'
  },
  {
    id: 41,
    url: tomatoMarigoldCloseup,
    thumbnailUrl: tomatoMarigoldCloseupThumb,
    description: 'Tomato leaves fill the frame above orange and yellow marigolds.'
  },
  {
    id: 42,
    url: trellisFabricCover,
    thumbnailUrl: trellisFabricCoverThumb,
    description: 'A tall sunflower, cucumber vines, basil, and covered seedlings grow around a trellis.'
  },
  {
    id: 43,
    url: vegetableRowsCropCovers,
    thumbnailUrl: vegetableRowsCropCoversThumb,
    description: 'Vegetable rows and fabric crop covers stretch across the growing beds.'
  },
  {
    id: 44,
    url: youngTomatoPlant,
    thumbnailUrl: youngTomatoPlantThumb,
    description: 'A young tomato plant is supported by a green cage in a raised bed.'
  },
  {
    id: 45,
    url: youngVegetableBedCover,
    thumbnailUrl: youngVegetableBedCoverThumb,
    description: 'Onions, cucumber vines, sunflower seedlings, and young vegetables grow beside a pulled-back cover.'
  },
  {
    id: 46,
    url: communityGardenWelcomeSign,
    thumbnailUrl: communityGardenWelcomeSignThumb,
    description: 'The Pleasant Playground Community Garden welcome sign hangs on the chain-link fence.'
  },
  {
    id: 47,
    url: compostBinsWithGardenScraps,
    thumbnailUrl: compostBinsWithGardenScrapsThumb,
    description: 'Fresh garden trimmings and leaves fill wooden compost bins beside the vine-covered fence.'
  },
  {
    id: 48,
    url: compostPileSignsOverBins,
    thumbnailUrl: compostPileSignsOverBinsThumb,
    description: 'Compost education signs hang above the compost bins and wooden bin lids.'
  },
  {
    id: 49,
    url: compostFoodWebSignCloseup,
    thumbnailUrl: compostFoodWebSignCloseupThumb,
    description: 'A food web diagram explains the organisms that break down material in the compost pile.'
  },
  {
    id: 50,
    url: decomposersCompostPileSignCloseup,
    thumbnailUrl: decomposersCompostPileSignCloseupThumb,
    description: 'A decomposers sign describes how organisms help turn garden scraps into compost.'
  },
  {
    id: 51,
    url: compostEducationSignsOnFence,
    thumbnailUrl: compostEducationSignsOnFenceThumb,
    description: 'The compost area sign and two educational posters sit among vines on the fence.'
  },
  {
    id: 52,
    url: compostBinsAndBrushPile,
    thumbnailUrl: compostBinsAndBrushPileThumb,
    description: 'Wooden compost bins hold dried branches and garden debris near the compost signage.'
  },
  {
    id: 53,
    url: tomatoBedWithBambooTrellis,
    thumbnailUrl: tomatoBedWithBambooTrellisThumb,
    description: 'Tomato plants grow through a bamboo trellis with basil, mint, and sunflowers nearby.'
  },
  {
    id: 54,
    url: zucchiniPlantWithYoungSquash,
    thumbnailUrl: zucchiniPlantWithYoungSquashThumb,
    description: 'A young zucchini grows among broad squash leaves and nearby herbs.'
  },
  {
    id: 55,
    url: pepperAndTomatoRaisedBed,
    thumbnailUrl: pepperAndTomatoRaisedBedThumb,
    description: 'Peppers, tomatoes, and eggplant grow together in a raised bed.'
  },
  {
    id: 56,
    url: cabbageChardAndLavenderBed,
    thumbnailUrl: cabbageChardAndLavenderBedThumb,
    description: 'Cabbage heads, Swiss chard, lavender, and row covers fill a mixed vegetable bed.'
  },
  {
    id: 57,
    url: stakedTomatoAndPepperBed,
    thumbnailUrl: stakedTomatoAndPepperBedThumb,
    description: 'Staked tomato plants and peppers grow in a square-grid raised bed near the fence.'
  },
  {
    id: 59,
    url: sunflowerFaceWithBee,
    description: 'A close view of a sunflower shows a bee gathering pollen on the flower head.'
  },
  {
    id: 60,
    url: sunflowerSideViewWithBuds,
    thumbnailUrl: sunflowerSideViewWithBudsThumb,
    description: 'A sunflower turns toward the garden with unopened buds clustered below it.'
  },
  {
    id: 61,
    url: redBeeBalmFlowerCloseup,
    thumbnailUrl: redBeeBalmFlowerCloseupThumb,
    description: 'A red bee balm flower blooms in sharp focus above a sunny bed of more bee balm.'
  },
  {
    id: 62,
    url: shastaDaisiesAndCalendulaBorder,
    thumbnailUrl: shastaDaisiesAndCalendulaBorderThumb,
    description: 'Shasta daisies, calendula, and young sunflowers grow in a straw-mulched flower border.'
  },
  {
    id: 63,
    url: foxgloveAndConeflowerGardenBorder,
    thumbnailUrl: foxgloveAndConeflowerGardenBorderThumb,
    description: 'Pink foxglove and purple coneflowers rise from a lush garden border beside row cover fabric.'
  },
  {
    id: 64,
    url: raisedBedsWithSeedlingTableAndRowCovers,
    thumbnailUrl: raisedBedsWithSeedlingTableAndRowCoversThumb,
    description: 'A seedling table sits between raised beds, trellises, and white row covers on the lawn.'
  },
  {
    id: 65,
    url: sunnyGardenBedsWithTomatoTrellises,
    thumbnailUrl: sunnyGardenBedsWithTomatoTrellisesThumb,
    description: 'Sunny raised beds hold tomato trellises, herbs, flowers, and covered crop rows.'
  },
  {
    id: 66,
    url: wideGardenBedsWithTrellisesAndRowCovers,
    thumbnailUrl: wideGardenBedsWithTrellisesAndRowCoversThumb,
    description: 'A wide view shows trellised vegetable beds, row covers, herbs, and open lawn.'
  },
  {
    id: 67,
    url: goldfinchOnTomatoCage,
    thumbnailUrl: goldfinchOnTomatoCageThumb,
    description: 'An American goldfinch perches on a tomato cage beside the garden fence.'
  },
  {
    id: 68,
    url: marigoldsLiatrisAndTomatoesRaisedBed,
    thumbnailUrl: marigoldsLiatrisAndTomatoesRaisedBedThumb,
    description: 'Marigolds, liatris, tomatoes, and sunflowers share a raised bed surrounded by vegetable plots.'
  },
  {
    id: 69,
    url: longGardenRowsWithCoveredBeds,
    thumbnailUrl: longGardenRowsWithCoveredBedsThumb,
    description: 'Long raised beds and covered crop rows run through the garden under a bright summer sky.'
  },
  {
    id: 70,
    url: wideGardenPathWithRaisedBeds,
    thumbnailUrl: wideGardenPathWithRaisedBedsThumb,
    description: 'A central grass path leads between raised beds, row covers, and flowering garden borders.'
  }
].map(withLightboxAspectRatio);

const featuredGalleryOrder = [
  59, 61, 62, 63, 1, 53, 56,
  2, 7, 60, 55, 57, 54, 68,
  23, 39, 22, 5, 26,
  67, 70, 66, 65, 64, 69,
  8, 29, 31, 32, 33, 40,
  41, 42, 45, 44, 27, 46,
  3, 4, 37, 35, 24, 12,
  15, 13, 17, 19, 43, 36,
  38, 11, 20, 25, 9, 28,
  10, 34, 30, 47, 52, 51,
  48, 49, 50
];

const galleryImagesById = new Map(
  galleryImageItems.map((image) => [image.id, image])
);

export const galleryImages = featuredGalleryOrder
  .map((id) => galleryImagesById.get(id))
  .filter(Boolean);
